var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2,.cls-4{fill:#b7b7b7;}.cls-3,.cls-4{stroke:#b7b7b7;stroke-miterlimit:10;}.cls-3{stroke-width:0.75px;}.cls-4{font-size:5.86px;stroke-width:0.25px;font-family:MyriadPro-Regular, Myriad Pro;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.74,2.6v8.12H7A3.68,3.68,0,0,1,6.84,10H6.35V9.3h.51A3.44,3.44,0,0,1,8.19,7H7.83c0-.22,0-.43,0-.69h.7V6.8a3.37,3.37,0,0,1,1.12-.42V2.6ZM5.53,10H4.84V9.28l.69,0Zm0-1.48H4.86V7.79h.69ZM4.86,7V6.31h.69V7ZM7,8.48H6.34V7.79H7ZM7,7H6.36V6.31H7ZM4.5,5.5V3.34H8.89V5.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.23,4.76H8.15V4.08H5.2C5.21,4.33,5.22,4.55,5.23,4.76Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.74,10.72V2.6H9.62V6.38a3.36,3.36,0,0,1,.63-.06h.13V1.84H3v9.6H7.28A3.82,3.82,0,0,1,7,10.72Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.5,3.34V5.5H8.89V3.34ZM8.15,4.76H5.23c0-.21,0-.43,0-.68h3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.86,6.31V7h.69V6.31Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.36,7H7V6.31H6.36Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.8,6.32c0,.26,0,.47,0,.69h.36L8.5,6.8V6.32Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.86,8.47h.69V7.79H4.86Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.34,8.48H7V7.79H6.34Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.84,10h.69v-.7l-.69,0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.35,10h.49a1.69,1.69,0,0,1,0-.23,3.25,3.25,0,0,1,0-.44H6.35Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.38,6.33h-.13A3.48,3.48,0,0,0,8.5,6.8L8.19,7A3.44,3.44,0,0,0,6.86,9.3a3.25,3.25,0,0,0,0,.44,1.69,1.69,0,0,0,0,.23,3.68,3.68,0,0,0,.13.75,3.82,3.82,0,0,0,.31.72,3.42,3.42,0,1,0,3.1-5.11Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(8.78 11.44)"
  }, "$")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudget);
export default __webpack_public_path__ + "static/media/budget.23c0aa34a5359aadfdd37f2d6852be38.svg";
export { ForwardRef as ReactComponent };